import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';
import { blockStyle } from '../../lib/blockStyle';

export const FailedDescription = styled.p`
  margin: 0 !important;
  padding-left: 10px;
  color: ${theme.color.designSystem.blackOpacity87};
`;

export const BlockButton = styled.button`
  background: none;
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.copy};
  font-family: ${theme.font.family.workSans};
  cursor: pointer;
  border: none;
  outline: none;
  padding: 0;
  color: ${theme.color.designSystem.purple70};
`;

export const Failed = styled.div<{ isSelected: boolean }>`
  ${blockStyle}
  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid ${theme.color.designSystem.error}`};
`;

export const FailedIcon = styled.div`
  svg {
    fill: ${theme.color.designSystem.error};
  }
`;

export const FileLink = styled.a<{ isSelected: boolean; as: string }>`
  ${blockStyle}
  display: block;
`;

export const FileLinkDetails = styled.div`
  display: flex;
  align-items: center;
  min-height: 44px;
`;

export const FileContainer = styled.div<{ maxContentWidth?: boolean }>`
  width: ${({ maxContentWidth }) => (maxContentWidth ? 'fit-content' : 'auto')};
  display: block;
  box-sizing: border-box;
  position: relative;
`;

export const FileEmbedContainer = styled.div`
  padding: ${theme.spacing.xxSmall};
  padding-top: ${theme.spacing.large};
  padding-left: ${theme.spacing.xLarge};
`;

export const FilePdfEmbedContainer = styled.div`
  width: 100%;
  min-height: 420px;
`;

export const BrokenFileContainer = styled.div`
  width: 508px;
  display: block;
  box-sizing: border-box;
  position: relative;
`;

export const VideoContainer = styled.div<{ isSelected: boolean }>`
  --plyr-color-main: ${theme.color.designSystem.purple60};
  --plyr-control-radius: ${theme.borderRadius.medium};
  --plyr-menu-radius: ${theme.borderRadius.medium};
  --plyr-tooltip-radius: ${theme.borderRadius.small};

  --plyr-font-family: ${theme.font.family.workSans};
  --plyr-font-size-base: ${theme.font.size.display};

  /* .plyr is the top level container for the player, created by Plyr, under VideoContainer */
  .plyr {
    border-radius: ${theme.borderRadius.medium};
  }

  border: ${({ isSelected }) =>
    isSelected
      ? `1px solid ${theme.color.designSystem.purple70}`
      : `1px solid transparent`};
`;

export const FileName = styled.span`
  padding-left: 7px;
  width: 100%;
`;

export const AudioContainer = styled.div<{ isSelected: boolean }>`
  ${blockStyle}
  display: block;
  cursor: pointer;
  padding: ${theme.spacing.small} ${theme.spacing.medium};
`;

export const AudioPlayerWrapper = styled.div`
  padding: ${theme.spacing.small} 0;
`;

export const Title = styled('div')`
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  font-weight: ${theme.font.weight.semiBold};
  font-family: ${theme.font.family.workSans};
`;

export const FailedAudioLoad = styled.div<{ isSelected: boolean }>`
  ${blockStyle}
  color: ${theme.color.designSystem.blackOpacity60};
  border: ${({ isSelected }) =>
    isSelected ? `1px solid ${theme.color.designSystem.purple70}` : `none`};
`;

export const HoverText = styled.figcaption<{ isSelected: boolean }>`
  position: absolute;
  transition: ${theme.transition.speed.default};
  bottom: 0;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0)};
  left: 0;
  padding: ${theme.spacing.small};
  padding-top: ${theme.spacing.xxGiant};
  height: auto;
  width: 100%;
  color: ${theme.color.white};
  font-size: ${theme.font.size.copy};
  max-width: 100%;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0,
    rgba(0, 0, 0, 0.8) 84px
  );
`;

export const ImageContainer = styled.figure<{
  collapsed: boolean;
  isSelected: boolean;
}>`
  ${blockStyle}
  position: relative;
  padding: 0;
  overflow: hidden;
  border-radius: ${theme.borderRadius.medium};
  margin: 12px 0;

  &:hover figcaption {
    opacity: 1;
  }

  ${({ collapsed }) =>
    collapsed &&
    `
    background: ${theme.color.designSystem.grey20};
    display: flex;
    align-items: start;
    width: 100%;

    img {
      width: 56px;
      height: auto;
      border-radius: 0;
    }

    & figcaption {
      transition: none;
      font-size: ${theme.font.size.copy};
      line-height: ${theme.font.lineHeight.copy};
      padding-top: ${theme.spacing.small};
      position: relative;
      opacity: 1;
      color: inherit;
      background: none;
    }`}
`;

export const ImageFileName = styled.span`
  display: block;
  color: ${theme.color.designSystem.blackOpacity60};
  margin-bottom: ${theme.spacing.xxxSmall};
  font-size: ${theme.font.size.small};
`;
